import AccountManagement from "./account";

export default AccountManagement;
